module.exports = __webpack_public_path__ + "static/media/2 7 Ordkjedetest-Starter-testen.d86c75be.mp3";